const FONT_STYLE_LIST = [
  { value: "Raleway", label: "Raleway" },
  { value: "Arial", label: "Arial" },
  { value: "Calibri", label: "Calibri" },
  { value: "Times New Roman", label: "Times New Roman" },
];

export default FONT_STYLE_LIST;
